export interface TillReportFunction {
    storeIds: number[];
    startDateTime: string | null;
    endDateTime: string | null;
    intervals?: TillPeriodGroupingIntervals;
}

export interface TillReportPeriodData {
    tillPeriodKey: string;
    tillPeriodDescription: string;
    rangeStartDate: string | null;
    rangeEndDate: string | null;
    total4GrossProfitRate: number;
    grossProfit: number;
    grossProfitRate: number;
    grossOTCSales_NonDebtor_SalesCount: number;
    grossOTCSales_NonDebtor_SalesValue: number;
    grossOTCSales_NonDebtor_Discounts_Count: number;
    grossOTCSales_NonDebtor_Discounts_Value: number;
    grossOTCSales_NonDebtor_Surcharges_Count: number;
    grossOTCSales_NonDebtor_Surcharges_Value: number;
    grossOTCSales_NonDebtor_PaymentSurcharges_Count: number;
    grossOTCSales_NonDebtor_PaymentSurcharges_Value: number;
    grossOTCSales_NonDebtor_GSTFree_SalesCount: number;
    grossOTCSales_NonDebtor_GSTFree_SalesValue: number;
    grossOTCSales_NonDebtor_GST_SalesCount: number;
    grossOTCSales_NonDebtor_GST_SalesValue: number;
    grossOTCSales_NonDebtor_GST_Value: number;
    grossOTCSales_Debtor_SalesCount: number;
    grossOTCSales_Debtor_SalesValue: number;
    grossOTCSales_Debtor_Discounts_Count: number;
    grossOTCSales_Debtor_Discounts_Value: number;
    grossOTCSales_Debtor_Surcharges_Count: number;
    grossOTCSales_Debtor_Surcharges_Value: number;
    grossOTCSales_Debtor_PaymentSurcharges_Count: number;
    grossOTCSales_Debtor_PaymentSurcharges_Value: number;
    grossOTCSales_Debtor_GSTFree_SalesCount: number;
    grossOTCSales_Debtor_GSTFree_SalesValue: number;
    grossOTCSales_Debtor_GST_SalesCount: number;
    grossOTCSales_Debtor_GST_SalesValue: number;
    grossOTCSales_Debtor_GST_Value: number;
    grossScriptSales_NonDebtor_SalesCount: number;
    grossScriptSales_NonDebtor_SalesValue: number;
    grossScriptSales_NonDebtor_Discounts_Count: number;
    grossScriptSales_NonDebtor_Discounts_Value: number;
    grossScriptSales_NonDebtor_Surcharges_Count: number;
    grossScriptSales_NonDebtor_Surcharges_Value: number;
    grossScriptSales_NonDebtor_PaymentSurcharges_Count: number;
    grossScriptSales_NonDebtor_PaymentSurcharges_Value: number;
    grossScriptSales_NonDebtor_GSTFree_SalesCount: number;
    grossScriptSales_NonDebtor_GSTFree_SalesValue: number;
    grossScriptSales_NonDebtor_GST_SalesCount: number;
    grossScriptSales_NonDebtor_GST_SalesValue: number;
    grossScriptSales_NonDebtor_GST_Value: number;
    grossScriptSales_NonDebtor_GovtContribution_Count: number;
    grossScriptSales_NonDebtor_GovtContribution_Value: number;
    grossScriptSales_Debtor_SalesCount: number;
    grossScriptSales_Debtor_SalesValue: number;
    grossScriptSales_Debtor_Discounts_Count: number;
    grossScriptSales_Debtor_Discounts_Value: number;
    grossScriptSales_Debtor_Surcharges_Count: number;
    grossScriptSales_Debtor_Surcharges_Value: number;
    grossScriptSales_Debtor_PaymentSurcharges_Count: number;
    grossScriptSales_Debtor_PaymentSurcharges_Value: number;
    grossScriptSales_Debtor_GSTFree_SalesCount: number;
    grossScriptSales_Debtor_GSTFree_SalesValue: number;
    grossScriptSales_Debtor_GST_SalesCount: number;
    grossScriptSales_Debtor_GST_SalesValue: number;
    grossScriptSales_Debtor_GST_Value: number;
    grossScriptSales_Debtor_GovtContribution_Count: number;
    grossScriptSales_Debtor_GovtContribution_Value: number;
    pettyCash_SalesCount: number;
    pettyCash_SalesValue: number;
    pettyCash_GST_Count: number;
    pettyCash_GST_Value: number;
    debtorPayments_Count: number;
    debtorPayments_Value: number;
    laybyPayments_Count: number;
    laybyPayments_Value: number;
    debtorCharges_Count: number;
    debtorCharges_Value: number;
    laybyPurchases_Count: number;
    laybyPurchases_Value: number;
    redeemedVouchers_Count: number;
    redeemedVouchers_Value: number;
    redeemedClubDollars_Count: number;
    redeemedClubDollars_Value: number;
    totalRounding_Count: number;
    totalRounding_Value: number;
    totalCashRounding_Value: number;
    refunds_Count: number;
    refunds_Value: number;
    voidedReceipts_Count: number;
    voidedReceipts_Value: number;
    agencySales_Count: number;
    agencySales_Value: number;
    agencySales_Commission_Count: number;
    agencySales_Commission_Value: number;
    purchasedVouchers_Count: number;
    purchasedVouchers_Value: number;
    savedSales_Count: number;
    savedSales_Value: number;
    totalReceipts: number;
    totalPeriodFloat: number;
    totalTakings: number;
    receiptIDTotals: number;
    cashPaymentValues: number;
    openDrawer_Count: number;
    excludeGovtContribution: boolean;
    isShownGrossProfit: boolean;
    totalSales_Count: number;
    totalSales_Value: number;
    totalOTCSales_Count: number;
    totalOTCSales_Value: number;
    prescriptionSales_Count: number;
    prescriptionSales_Value: number;
    prescriptionSales_Inc_Govt_Value: number;
    totalGovtContrib_Count: number;
    totalGovtContrib_Value: number;
    totalTillTurnover: number;
    totalStoreTakings: number;
    total_NonDebtor_Sales_Count: number;
    total_NonDebtor_Sales_Value: number;
    gSTFree_NonDebtor_Sales_Count: number;
    gSTFree_NonDebtor_Sales_Value: number;
    gST_NonDebtor_Sales_Count: number;
    gST_NonDebtor_Sales_Value: number;
    total_Debtor_Sales_Count: number;
    total_Debtor_Sales_Value: number;
    gSTFree_Debtor_Sales_Count: number;
    gSTFree_Debtor_Sales_Value: number;
    gST_Debtor_Sales_Count: number;
    gST_Debtor_Sales_Value: number;
    total_GST_Free_Sales_Count: number;
    total_GST_Free_Sales_Value: number;
    total_GST_Sales_Count: number;
    total_GST_Sales_Value: number;
    total_GST_Collected_Value: number;
    less_Total_Govt_Contrib_Count: number;
    less_Total_Govt_Contrib_Value: number;
    avg_OTCSales_PerCustomer_Count: number;
    avg_OTCSales_PerCustomer_Value: number;
    avg_PrescriptionSales_PerCustomer_Count: number;
    avg_PrescriptionSales_PerCustomer_Value: number;
    totalDiscounts_Count: number;
    totalDiscounts_Value: number;
    avg_Discounts_PerCustomer_Count: number;
    avg_Discounts_PerCustomer_Value: number;
    totalSurcharge_Count: number;
    totalSurcharge_Value: number;
    avg_Surcharge_PerCustomer_Count: number;
    avg_Surcharge_PerCustomer_Value: number;
    totalPaymentSurcharge_Count: number;
    totalPaymentSurcharge_Value: number;
    avg_PaymentSurcharge_PerCustomer_Count: number;
    avg_PaymentSurcharge_PerCustomer_Value: number;
    paymentData: PaymentInfo[];
}

export interface PaymentInfo {
    description: string;
    paymentCount: number;
    paymentAmount: number;
    paymentGroup: string;
}

export enum TillPeriodGroupingIntervals {
    Daily,
    Weekly,
    Monthly,
    Yearly,
    FinancialYear,
    Custom
}